// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4m-5";
export var imageContainer = "_4m-4";
export var metricsGrid = "_4m-2";
export var productDetailContainer = "_4m-1";
export var productListContainer = "_4m-0";
export var subscriberTableContainer = "_4m-3";